import { Form, Input } from 'antd';

/** Billing address subform, shared by the create and edit customer forms — same Form.Item names in both. */
export function BillingAddressFields() {
  return (
    <>
      <Form.Item name="billingAddressLine1" label="Billing address" rules={[{ required: true, message: 'Enter the billing address' }]}>
        <Input placeholder="Address line 1" />
      </Form.Item>
      <Form.Item name="billingAddressLine2">
        <Input placeholder="Address line 2 (optional)" />
      </Form.Item>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="billingAddressCity" label="City" rules={[{ required: true, message: 'Enter a city' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="billingAddressCountry" label="Country" rules={[{ required: true, message: 'Enter a country' }]}>
          <Input />
        </Form.Item>
      </div>
    </>
  );
}
